import { useEffect } from 'react';
import { EMPTY_STRING, NO_OP } from "../../constants/Constants";
import Pusher from 'pusher-js';
import TokenManager from '../../utils/TokenManager';
export const usePusher = function (_ref) {
  let {
    channelName,
    eventName,
    authEndpoint,
    key = EMPTY_STRING,
    cluster = EMPTY_STRING
  } = _ref;
  let successCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NO_OP;
  useEffect(() => {
    let pusher;
    if (key && cluster) {
      try {
        pusher = new Pusher(key, {
          cluster,
          authEndpoint,
          auth: {
            headers: {
              'tap-api-token': TokenManager.getItem(TokenManager.accessTokenKey)
            }
          }
        });
      } catch (e) {
        return;
      }
      const channel = pusher.subscribe(channelName);
      channel.bind(eventName, () => {
        successCallback();
      });
    }
    return () => {
      var _pusher;
      (_pusher = pusher) === null || _pusher === void 0 || _pusher.disconnect();
    };
  }, [key, cluster]);
};